import { render, staticRenderFns } from "./comment.vue.html?vue&type=template&id=06d6b9f0&scoped=true"
import script from "./comment.controller.ts?vue&type=script&lang=js&external"
export * from "./comment.controller.ts?vue&type=script&lang=js&external"
import style0 from "./comment.vue.html?vue&type=style&index=0&id=06d6b9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d6b9f0",
  null
  
)

export default component.exports